import './aEditor.min.css'
//import './fontawesome-all.min.css'
import './App.css';

import { useState  } from 'react';
import { useFolders } from "./hooks/folders";
import { useFiles } from "./hooks/files";
import Folder from './components/Folder';
import File from './components/File';
//import Breadcrumb from './components/Breadcrumb'; 
import { useCrumbs } from './helpers/crumbs';
//import { useAuthHeader } from './helpers/authHeader';
import BreadcrumbList from './components/BreadcrumbList';
import '../node_modules/iframe-resizer/js/iframeResizer.contentWindow';
import TokenService from "./services/token.service";
//import axios from 'axios';
//import {  useQuery } from "react-query";

const App = () => {
const urlParams = new URLSearchParams(window.location.search);
var tempPath = urlParams.get("path"); 
const path = tempPath === null ? "/Public" : urlParams.get("path");
//console.log(path);
 

const [currentFolderURL, setCurrentFolderURL] = useState(`/sites/PublicWebsiteDocuments${path}`);
const crumbs2= useCrumbs(currentFolderURL);
let count= crumbs2.length;
let tempName = crumbs2[count-1].name
const currentFolderName =tempName;  // useState(tempName); 
const folders = useFolders(currentFolderURL); 
let token = TokenService.getLocalAccessToken()
const files = useFiles(currentFolderURL, token); 


 /*
 if (folders.data){
  console.log("Folders: " + folders.data.d.results);
 }

 if (files.data){
 console.log("Files: " +files); 
 }*/
 /*     {files.data &&
       files.data.d.results.map((file) => <File key={file.UniqueId} name={file.Name} LinkToItem={file.LinkToItem} />)}*/

  return (
    <div className="App col-xs-12 col-md-8 col-lg-9 cp-placeholder" id="maincontent"  >
      <div className="document-centre magiq-documents">
      <h1 id="PublicFolderWilunaHeading">Documents {'>'} {currentFolderName}</h1>
      <BreadcrumbList crumbs={crumbs2}></BreadcrumbList>
      <div class="table-responsive">
                    <table width="100%" className="documentcentre-doclist table table-striped">
                      <tbody><tr>
                            <th scope="col">Document</th>
                        </tr>
      {folders.data &&
       folders.data.d.results.map((folder) => 
       <Folder key={folder.Name} name={folder.Name} currentFolderURL={currentFolderURL}
          setCurrentFolderURL={setCurrentFolderURL} />)}
      {files.data &&
       files.data.d.results.map((file) => <File key={file.UniqueId} name={file.Name} LinkToItem={file.LinkToItem} />)}
 
      </tbody></table>
      </div>

    </div>
    </div>
  );


};


export default App;
 